<template lang="pug">
  div(class="file-not-found-page")
    h3 We couldn't find the page you're looking for.
    p Apparently we're better at finding apartments than we are at finding web pages!
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
.file-not-found-page{
  min-height: 400px;
}
h3{
  font-size: 1.5em;
  color: rgb(145, 150, 167);
}
</style>